import React from 'react'

import { Col, Container, Row } from "react-bootstrap";
import choose_us from "../../assets/images/aboutUspage/c.jpg.svg";

import arrow_list from "../../assets/images/aboutUspage/list arrow.svg";


function Whychooseus() {
  const features = [
    "Customer satisfaction is our highest priority",
    "Agile processes that welcome changing requirements",
    "Motivated individuals and trusted environment",
    "Face-to-face conversation for efficient communication",
    "Sustainable development through agile methods",
    "Continuous attention to technical excellence"
  ];

  return (
    <div className="choose_us py-100" style={{ background: 'var(--bg-light)' }}>
      <Container>
        <div className="row align-items-center">
          <Col lg={6} className="mb-5 mb-lg-0">
            <div className="pe-lg-5">
              <div className="about-badge mb-3">Why Choose Us</div>
              <h2 className="about-title mb-4">
                We Are Experts In <br />
                <span className="gradient-text">IT Solutions</span>
              </h2>
              <p className="about-description mb-5">
                We provide flexible timing, competitive compensation, and a healthy work 
                environment. Diversity is critical to our innovation and is a central 
                part of our culture.
              </p>
              
              <div className="why-choose-grid">
                {features.map((feature, index) => (
                  <div className="choose-card" key={index}>
                    <div className="feature-item mb-0">
                      <div className="feature-icon-wrapper">
                        <i className="fa-regular fa-star"></i>
                      </div>
                      <div>{feature}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Col>
          
          <Col lg={6}>
            <div className="about-image-wrapper">
              <img src={choose_us} style={{ width: "100%", height: "auto" }} className='whyChooseUsimage' alt="Why Choose Us" />
            </div>
          </Col>
        </div>
      </Container>
    </div>
  )
}


export default Whychooseus;
